import { CommonResponse } from "@gtpl/shared-models/production-management";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AssetsSaleService } from "./asset-sale.service";
import { AssetsSaleDto } from "./dto/asset-sale.dto";
import { AssetByStatus } from "../open-assets/dto/asset-by-status.dto";
import { AssetByAssetCode } from "../asset-assignment/dto/get-by-assetCode.dto";

@ApiTags('assetsSale')
@Controller('assetsSale')

export class AssetsSalesController {
    constructor(
        private service: AssetsSaleService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createAssetSale')
    async createAssetSale(@Body() req: AssetsSaleDto): Promise<CommonResponse> {
        try {
            return await this.service.createAssetSale(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getAssetSaleDetails')
    async getAssetSaleDetails(@Body() req?:AssetByAssetCode): Promise<CommonResponse> {
        try {
            return await this.service.getAssetSaleDetails(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getassetCodeDropDownforAssetSale')
    async getassetCodeDropDownforAssetSale(@Body() req: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.service.getassetCodeDropDownforAssetSale(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getassetCategoryDropDownforAssetSale')
    async getassetCategoryDropDownforAssetSale(@Body() req: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.service.getassetCategoryDropDownforAssetSale(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/assetCodeDropdownforAssetSaleGrid')
    async assetCodeDropdownforAssetSaleGrid(@Body() req: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.service.assetCodeDropdownforAssetSaleGrid(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

}